import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { icons } from "@/components/Base/Lucide";

export interface Menu {
  icon: keyof typeof icons;
  title: string;
  badge?: number;
  pathname?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}

export interface SideMenuState {
  menu: Array<Menu | string>;
  selectedUserId?: string;
}

const initialState: SideMenuState = {
  menu: [
    "MANAGE",
    {
      icon: "Package",
      pathname: "/products",
      title: "Product",
    },
    {
      icon: "Users",
      pathname: "/users",
      title: "User",
    },
    {
      icon: "Store",
      pathname: "/outlets",
      title: "Outlet",
    },

    
  ],
  selectedUserId: undefined,
};

export const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    setCompanyId: (state, action) => {
      const companyId = action.payload;

      // Update the pathname for company-specific items
      state.menu = state.menu.map((item) => {
        if (typeof item !== "string") {
          if (item.title === "User") {
            return { ...item, pathname: `/users?companyId=${companyId}` };
          }
          if (item.title === "Product") {
            return { ...item, pathname: `/products?companyId=${companyId}` };
          }
          if (item.title === "Team") {
            return { ...item, pathname: `/teams?companyId=${companyId}` };
          }
        }
        return item;
      });
    },
    setUserId: (state, action) => {
      state.selectedUserId = action.payload;
    }
  },
});

export const { setCompanyId, setUserId } = sideMenuSlice.actions;

export const selectSideMenu = (state: RootState) => state.sideMenu.menu;

export default sideMenuSlice.reducer;

